
import React from 'react';
import { Icons } from '../ui/Icons';

const ReportsView: React.FC = () => {
    return (
        <div className="space-y-6 max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                        <Icons.FileText className="w-6 h-6 text-indigo-600" />
                        Reports
                    </h1>
                    <p className="text-gray-500 dark:text-gray-400 mt-1">Generate and view system reports</p>
                </div>
            </div>

            <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-gray-200 dark:border-slate-700 p-12 flex flex-col items-center justify-center text-center">
                <div className="w-16 h-16 bg-indigo-50 dark:bg-indigo-900/20 rounded-full flex items-center justify-center mb-4">
                    <Icons.FileText className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Reports Module</h2>
                <p className="text-gray-500 dark:text-gray-400 max-w-md">
                    This module is currently under development. Soon you will be able to generate detailed reports for scheduling, shuttle usage, and parking analytics.
                </p>
            </div>
        </div>
    );
};

export default ReportsView;
